import styled from "styled-components"
export const SecondaryTitle = styled.h2`
  font-size: 28px;
  margin: 25px 0 10px 0;

  @media (max-width: 811px) {
    padding: 10px;
    margin: 25px 0 0 0;
  }
`
